(function($, Drupal) {
  "use strict";
  Drupal.behaviors.laakevarmennus = {
    attach: function(context, settings) {
      if (navigator.platform == "Win32") {
        $("body").addClass("windows-machine");
      }

      $(window).on("load", function() {
        var faqToggle = $(".paragraph--type--faq .field--name-field-question");

        faqToggle.click(function(ev) {
          $(this)
            .parent()
            .toggleClass("show");
        });
      });

      // Check if anchor links div is empty
      var $anchorLinksItem = $(".field--name-field-anchor-links>.field__item");
      if ($anchorLinksItem.length && !$.trim($anchorLinksItem.html()).length) {
        $(".field--name-field-anchor-links").addClass("empty");
      }

      // Publication pages menu functions for FI, EN and SV
      $("#block-publ-menu-fi ul.menu").each(function () {
        var depth = $(this).parents("ul").length;
        $(this).addClass("level-" + depth);
      });

      $("#block-publ-menu-en ul.menu").each(function () {
        var depth = $(this).parents("ul").length;
        $(this).addClass("level-" + depth);
      });

      $("#block-publ-menu-sv ul.menu").each(function () {
        var depth = $(this).parents("ul").length;
        $(this).addClass("level-" + depth);
      });

      var publBlockExpArray = ["#block-publ-menu-fi .menu-item--expanded", "#block-publ-menu-en .menu-item--expanded", "#block-publ-menu-sv .menu-item--expanded"];

      $(publBlockExpArray).each(function () {
        $('<span class="collapse-button"></span>').insertAfter($(this).children("a"));
      });

      var $publ_sidebar_block = $(".publication .region-sidebar-first"),
        $collapser = $(".collapser", $publ_sidebar_block),
        $sub_collapser = $(".menu-item--expanded>.collapse-button", $publ_sidebar_block),
        $menu = $(".menu", $publ_sidebar_block),
        $level0 = $(".menu.level-0", $publ_sidebar_block),
        $level1 = $(".menu.level-1", $publ_sidebar_block),
        opened = false;

      $collapser.click(function () {
        $collapser.toggleClass("open");
        $menu.toggleClass("menu-open").trigger('collapseChange');
        $level0.toggleClass("show").trigger('collapseChange');
        if (!opened) {
          $("li.menu-item--active-trail", $menu).addClass("active-trail-open").trigger("classChange").children("ul").addClass("menu-open").show();
          opened = true;
        }
      });

      $sub_collapser.click(function () {
        if ($("li.menu-item--active-trail.menu-item--expanded", $menu).hasClass("active-trail-open")) {
          $sub_collapser.toggleClass("active-collapse");
          $level1.toggleClass("hide").trigger('collapseChange');
        } else {
          $sub_collapser.toggleClass("open");
          $level1.toggleClass("show").trigger('collapseChange');
        }
      });

      $(document).ready(function() {
        // Back to top functionality
        var offset = 220;
        var duration = 300;

        $(window).on('scroll', function () {
          if ($(this).scrollTop() > offset) {
            $(".back-to-top").fadeIn(duration);
          } else {
            $(".back-to-top").fadeOut(duration);
          }
        });

        $(".back-to-top").on('click', function (event) {
          event.preventDefault();
          $("html, body").animate({ scrollTop: 0 }, duration);
          return false;
        });

        // Check if highlights exist and count highlight items
        if ($(".field--name-field-highlight").length) {
          var highlightCount = $(".field--name-field-highlight > .field__item").length;
          console.log("Highlight count: " + highlightCount);
          if (highlightCount >= 7) {
            $(".field--name-field-highlight").addClass("multiple-rows");
          } else {
            $(".field--name-field-highlight").removeClass("multiple-rows");
          }
        } else {
          return;
        }
      });
    }
  };
})(jQuery, Drupal);
